interface EllipsisAddressOptions {
	address: string
	prefixLength?: number
	suffixLength?: number
}

export function formatAddress({
	address,
	prefixLength = 4,
	suffixLength = 4,
}: EllipsisAddressOptions): string {
	const uppercaseAddress = address.toUpperCase()

	if (prefixLength + suffixLength >= uppercaseAddress.length) {
		return uppercaseAddress
	}

	const prefix = uppercaseAddress.slice(0, prefixLength)
	const suffix = uppercaseAddress.substring(address.length - suffixLength)

	return `${prefix}...${suffix}`
}
